import { Grid, Typography } from "@material-ui/core";

import MeditocInfoField from "../../../utils/MeditocInfoField";
import MeditocModal from "../../../utils/MeditocModal";
import { useColaborador } from "../../../../context/ColaboradorContext";

export default function EliminarColaborador() {
    const {
        colaboradorSeleccionado,
        modalOpenEliminarColaborador,
        handleOpenEliminarColaborador,
        handleSubmitEliminarColaborador,
    } = useColaborador();

    return (
        <MeditocModal
            title="Eliminar colaborador"
            open={modalOpenEliminarColaborador}
            setopen={handleOpenEliminarColaborador}
            okfunc={handleSubmitEliminarColaborador}
            align="center"
            size="small"
        >
            <Grid container spacing={1} className="center">
                <Grid item xs={12}>
                    <Typography paragraph>¿Desea eliminar el colaborador seleccionado?</Typography>
                </Grid>
                {colaboradorSeleccionado.bAcceso && (
                    <Grid item xs={12}>
                        <Typography paragraph variant="body2">
                            El usuario perderá acceso al Portal de Meditoc
                        </Typography>
                    </Grid>
                )}
                <Grid item xs={12}>
                    <MeditocInfoField label="ID de colaborador:" value={colaboradorSeleccionado.iIdColaborador} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField
                        label="Nombre de colaborador:"
                        value={colaboradorSeleccionado.sNombreDirectorio}
                    />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Tipo de colaborador:" value={colaboradorSeleccionado.sTipoDoctor} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Especialidad:" value={colaboradorSeleccionado.sEspecialidad} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Usuario titular:" value={colaboradorSeleccionado.sUsuarioTitular} />
                </Grid>
                {colaboradorSeleccionado.sUsuarioAdministrativo && (
                    <Grid item xs={12}>
                        <MeditocInfoField
                            label="Usuario administrativo:"
                            value={colaboradorSeleccionado.sUsuarioAdministrativo}
                        />
                    </Grid>
                )}
            </Grid>
        </MeditocModal>
    );
}
